export default "__VITE_ASSET__e1c91cac__"